"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Submissions = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var models_1 = require("../../../models");
var Button_1 = require("../Button");
var BUTTON_ITEM_CLASS_NAME = "_buttonItem";
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  > .", " + .", " {\n    margin-top: 16px;\n  }\n"], ["\n  text-align: center;\n  > .", " + .", " {\n    margin-top: 16px;\n  }\n"])), BUTTON_ITEM_CLASS_NAME, BUTTON_ITEM_CLASS_NAME);
var Submissions = function (_a) {
    var submissions = _a.submissions, onPreviousButtonClick = _a.onPreviousButtonClick, onNextButtonClick = _a.onNextButtonClick, disabled = _a.disabled, design = _a.design, className = _a.className;
    var submitButtonBackground = design.colors.submitButtonBackground;
    return (react_1.default.createElement(StyledWrapper, { className: className }, submissions.map(function (button) {
        if (button.type === models_1.FORM_PAGE_BUTTON_TYPE.next) {
            return (react_1.default.createElement("div", { className: BUTTON_ITEM_CLASS_NAME, key: button.type },
                react_1.default.createElement(Button_1.Button, { type: "button", backgroundColor: submitButtonBackground, buttonType: button.type, disabled: disabled.next, onClick: function () {
                        if (onNextButtonClick) {
                            onNextButtonClick(button.endpoint);
                        }
                    } }, button.label)));
        }
        if (button.type === models_1.FORM_PAGE_BUTTON_TYPE.previous) {
            return (react_1.default.createElement("div", { className: BUTTON_ITEM_CLASS_NAME, key: button.type },
                react_1.default.createElement(Button_1.Button, { type: "button", backgroundColor: submitButtonBackground, buttonType: button.type, disabled: disabled.previous, onClick: function () {
                        if (onPreviousButtonClick) {
                            onPreviousButtonClick(button.endpoint);
                        }
                    } }, button.label)));
        }
        return (react_1.default.createElement("div", { className: BUTTON_ITEM_CLASS_NAME, key: button.type },
            react_1.default.createElement(__1.LinkButton, { href: button.siteUrl, target: button.target, backgroundColor: submitButtonBackground, buttonType: button.type, disabled: disabled.externalLink }, button.label)));
    })));
};
exports.Submissions = Submissions;
var templateObject_1;
